<template>
    <div class="animated fadeIn bulk-create-item-page">
        <loader v-if="isOverlay"></loader>
        <b-row>
            <b-col cols="12" md="12">
                <transition name="fade">
                    <b-card
                        border-variant="info"
                        header-bg-variant="primary"
                        header-text-variant="white"
                    >
                        <div slot="header">
                            <span class="font-size-20 font-weight-bold">Bulk Item Creation</span>
                            <b-button
                                @click="$router.push({ path: '/item' })"
                                class="font-size-15 float-right"
                                variant="primary"
                            >
                                Go Back
                            </b-button>
                        </div>
                        <b-tabs v-model="tabIndex" @input="tabActivated">
                            <b-tab title="Upload Bulk Item">
                                <b-row>
                                    <b-col>
                                        <transition name="fade">
                                            <b-card
                                                border-variant="info"
                                                header-bg-variant="primary"
                                                header-text-variant="white"
                                            >
                                                <b-row>
                                                    <b-col cols="12" sm="12" md="5" class="my-1">
                                                        <b-form-group label-cols-sm="3" class="mb-0">
                                                            <b-input
                                                                readonly
                                                                :value="`Category : ${catalogData.name}`"
                                                            />
                                                        </b-form-group>
                                                    </b-col>
                                                    <b-col cols="12" sm="12" md="2" class="my-1">
                                                        <b-button
                                                            variant="primary"
                                                            @click="downloadTemplate"
                                                        >
                                                            Download Template
                                                        </b-button>
                                                    </b-col>
                                                </b-row>
                                                <b-row>
                                                    <b-col cols="12" sm="12" md="6" class="my-1">
                                                        <b-form-file
                                                            placeholder="Select an Images Zip File"
                                                            @change="selectZipFile"
                                                            drop-placeholder="Drop file here..."
                                                        />
                                                    </b-col>
                                                    <b-col cols="12" sm="12" md="6" class="my-1">
                                                        <b-form-file
                                                            placeholder="Select CSV File"
                                                            @change="selectFile"
                                                            drop-placeholder="Drop file here..."
                                                        />
                                                    </b-col>
                                                </b-row>
                                                <b-row>
                                                    <b-col class="text-center">
                                                        <b-button
                                                            variant="primary"
                                                            :disabled="!selectedFile || !selectedZipFile"
                                                            @click="uploadFile"
                                                        >
                                                            Upload
                                                        </b-button>
                                                    </b-col>
                                                </b-row>
                                            </b-card>
                                        </transition>
                                    </b-col>
                                </b-row>

                                <!-- Import history: table with filters -->
                                <section class="mt-4">
                                    <component-header
                                        title="Import History"
                                        @search-query="(val) => (filter = val)"
                                        :isLoading="loading"
                                        @reload-data="getBulkItemList"
                                        :hasCreate="false"
                                    />
                                    <b-card class="card-wrap" border-variant="info">
                                        <b-row>
                                            <b-col cols="12" sm="12" md="2">
                                                <b-form-group label-cols-sm="3" class="mb-0">
                                                    <label>Time Period</label>
                                                    <eb-select
                                                        type="select"
                                                        v-model="selectedPeriod"
                                                        :options="periodList"
                                                        label="text"
                                                        id="selecttime"
                                                        :selected="selectedPeriod"
                                                        @input="getBulkItemList"
                                                    />
                                                </b-form-group>
                                            </b-col>
                                            <b-col cols="12" sm="12" md="2">
                                                <label>Status</label>
                                                <eb-select
                                                    type="select"
                                                    v-model="selectedStatus"
                                                    :options="statusTypes"
                                                    label="text"
                                                    id="selectstatus"
                                                    :selected="selectedStatus"
                                                    @input="getBulkItemList"
                                                />
                                            </b-col>
                                        </b-row>
                                        <div>
                                            <b-table
                                                class="tableRadius professional-stacked-table"
                                                :fields="Columns"
                                                :items="bulkReportList"
                                                :dark="false"
                                                :filter="filter"
                                                :hover="true"
                                                thead-class="header"
                                                :striped="false"
                                                :bordered="true"
                                                :current-page="currentPage"
                                                :per-page="10"
                                                :small="false"
                                                show-empty
                                                :fixed="false"
                                                responsive
                                                stacked="md"
                                            >
                                                <template slot="cell(createdAt)" slot-scope="{ item }">
                                                    <div>{{ item.createdAt | formatedate }}</div>
                                                </template>
                                                <template slot="cell(inputSheet)" slot-scope="{ item }">
                                                    <b-button
                                                        variant="primary"
                                                        @click="downloadSheet(item.inputSheet)"
                                                    >
                                                        Download
                                                    </b-button>
                                                </template>
                                                <template slot="outputSheet" slot-scope="{ item }">
                                                    <b-button
                                                        variant="primary"
                                                        @click="downloadSheet(item.outputSheet)"
                                                    >
                                                        Download
                                                    </b-button>
                                                </template>
                                                <template slot="paymentResponse.paymentMode" slot-scope="{ item }">
                                                    <div>{{ item.paymentResponse.paymentMode | formatMode }}</div>
                                                </template>
                                                <template slot="cell(empty)">
                                                    <div v-if="loading" class="text-center">
                                                        <span><b>Loading...</b></span>
                                                    </div>
                                                    <div v-else class="text-center">No data available.</div>
                                                </template>
                                            </b-table>
                                        </div>
                                        <div class="d-flex justify-content-end">
                                            <b-pagination
                                                v-model="currentPage"
                                                :per-page="10"
                                                :total-rows="bulkReportList.length"
                                                aria-controls="my-table"
                                                prev-text="Prev"
                                                next-text="Next"
                                            />
                                        </div>
                                    </b-card>
                                </section>
                            </b-tab>
                        </b-tabs>
                    </b-card>
                </transition>
            </b-col>
        </b-row>
    </div>
</template>

<script>
import { mapActions } from "vuex";
import { AtomSpinner } from "epic-spinners";
import * as FileSaver from "file-saver";
import Vue from "vue";
import ebSelect from "@/components/FormElements/Select.vue";
import moment from "moment";
import ComponentHeader from "@/components/componentNewHeader";
import loader from "@/components/loader/nipigeloader.vue";

const PERIOD_LIST = [
    { text: "Last 7 days", value: 7 },
    { text: "Last 15 days", value: 15 },
    { text: "Last 30 days", value: 30 },
    { text: "Last 3 Months", value: 90 },
    { text: "Last 6 Months", value: 180 },
];

const HISTORY_COLUMNS = [
    { key: "jobType", label: "Job Type", sortable: false },
    { key: "importedBy.name", label: "Imported By" },
    { key: "status", label: "Status", sortable: false },
    { key: "createdAt", label: "Date", sortable: true },
    { key: "inputSheet", label: "Input Sheet", sortable: false },
    { key: "outputSheet", label: "Output Sheet", sortable: false },
];

export default {
    name: "BulkItemCreate",
    components: {
        AtomSpinner,
        ebSelect,
        ComponentHeader,
        loader,
    },
    data() {
        return {
            tabIndex: 0,
            transProps: { name: "flip-list" },
            isOverlay: false,
            loading: false,
            selectedFile: null,
            selectedZipFile: null,
            selectedImageFile: null,
            uploadedZipFile: null,
            catalogData: {},
            uploadedURL: "",
            statusTypes: ["PROCESSED", "PROCESSING", "UPLOADED"],
            selectedStatus: "PROCESSED",
            currentPage: 1,
            selectedPeriod: { text: "Last 7 days", value: 7 },
            periodList: PERIOD_LIST,
            filter: "",
        };
    },
    computed: {
        Columns() {
            return HISTORY_COLUMNS;
        },
        bulkReportList() {
            const dataList = this.$store.getters["item/GetBulkItemReport"];
            if (!dataList || dataList.length === 0) return [];
            return [...dataList].sort(
                (a, b) => new Date(b.createdAt) - new Date(a.createdAt)
            );
        },
    },
    filters: {
        formatedate(value) {
            return value
                ? moment(String(value)).format("DD/MM/YYYY hh:mm A")
                : "";
        },
    },
    mounted() {
        this.getCatalog();
        this.getBulkItemList();
    },
    methods: {
        ...mapActions({
            DownloadTemplate: "item/downloadItemTemplate",
            UploadFile: "inventory/uploadFileToStorage",
            bulkImport: "item/bulkItemImport",
        }),

        // --- Upload flow ---
        buildUploadFormData() {
            const formData = new FormData();
            formData.append("imageArchiveFile", this.selectedZipFile);
            formData.append("dataFile", this.selectedFile);
            formData.append("catalogId", this.$route.params.id);
            formData.append("name", this.$currentUserData.userName);
            return formData;
        },
        async uploadFile() {
            const formData = this.buildUploadFormData();
            this.showCustomToast();
            this.isOverlay = true;
            try {
                await this.bulkImport(formData);
                this.isOverlay = false;
                this.clearCustomToast();
                this.$swal({
                    type: "success",
                    text: "Bulk Items Created Successfully!",
                });
                this.selectedFile = null;
                this.selectedZipFile = null;
                this.getBulkItemList();
            } catch {
                this.loading = false;
                this.isOverlay = false;
            }
        },

        // --- Template download ---
        downloadTemplate() {
            this.loading = true;
            this.DownloadTemplate(this.$route.params.id)
                .then((blob) => {
                    FileSaver.saveAs(
                        blob,
                        `${this.catalogData.name}_template.xlsx`
                    );
                })
                .catch(() => {})
                .finally(() => {
                    this.loading = false;
                });
        },

        // --- File handling ---
        selectFile(event) {
            setTimeout(() => {
                this.selectedFile = event.target?.files?.[0] || null;
            }, 500);
        },
        selectZipFile(event) {
            setTimeout(() => {
                this.selectedZipFile = event.target?.files?.[0] || null;
            }, 500);
        },

        // --- History fetch ---
        getBulkItemList() {
            const payload = {
                days: this.selectedPeriod.value,
                status: this.selectedStatus,
            };
            this.loading = true;
            this.$store
                .dispatch("item/getBulkReport", payload)
                .finally(() => {
                    this.loading = false;
                });
        },
        downloadSheet(url) {
            if (url) window.open(url, "_blank");
        },

        // --- Catalog ---
        getCatalog() {
            this.$store
                .dispatch("catalog/fetchCatalogById", this.$route.params.id)
                .then((result) => {
                    if (result?.status === 1) {
                        this.catalogData = result.response;
                    }
                });
        },

        // --- Toast ---
        showCustomToast() {
            Vue.toasted.show("Uploading...", {
                type: "info",
                theme: "toasted-primary",
                singleton: true,
                duration: 1000000,
            });
        },
        clearCustomToast() {
            Vue.toasted.clear();
        },

        // --- Tab ---
        tabActivated() {
            const uploadEl = document.getElementById("upload-image");
            if (uploadEl) uploadEl.value = "";
            this.selectedImageFile = "";
            this.uploadedURL = "";
        },
    },
};
</script>

<style>
.mymodalclass > div {
    margin-top: 45px !important;
}
.text-center {
    text-align: center !important;
}
[data-font="20"] {
    font-size: 20px;
}
.edit {
    color: #ffffff !important;
}
.bin {
    color: white !important;
}

.bulk-create-item-page table.table-bordered > tbody > tr {
    /* text-transform: capitalize; */
    text-align: center;
}
.bulk-create-item-page table#table-transition-example .flip-list-move {
    transition: transform 1s;
}
</style>
<style></style>
